import AttendeeInfo from '@composites/AttendeeInfo';
import CompanyInfo from '@composites/CompanyInfo';
import Sessions from '@composites/Sessions';
import HeroSection from '@composites/HeroSection';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getEventDetails } from '@store/slices/eventSlice';
import { useGetPublicSpeakerDetails } from '@utils/apiHooks';
import { adminEventsRouteFormat } from '@constants/paths';
import { MetaTags } from '@components/MetaTags';
import { getImageSrc } from '@utils/fn';

const SpeakerPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const { data: speakerDetails, isLoading } = useGetPublicSpeakerDetails({
    speakerId: id ?? '',
    eventId: sluggedEvent?.id,
  });
  const { pathname } = useLocation();
  const pathSegments = pathname.split('/').filter(Boolean);
  const secondLastSegment = pathSegments[pathSegments.length - 2];

  // Redirect to 404 page if the speaker isn't found
  useEffect(() => {
    if (id && sluggedEvent?.slug && !speakerDetails?.data && !isLoading) {
      navigate(adminEventsRouteFormat(sluggedEvent.slug, '404'));
    }
  }, [id, navigate, sluggedEvent?.slug, speakerDetails, isLoading]);

  return (
    <>
      <MetaTags
        title={`${String(sluggedEvent?.name ?? '')} ${String(speakerDetails?.data?.first_name ?? '')} ${String(speakerDetails?.data?.last_name ?? '')}`}
        description={`${String(speakerDetails?.data?.sessions?.map((item: any) => item?.title).join(', ') ?? '')}`}
        keywords={`${String(sluggedEvent?.slug ?? '')}, ${String(secondLastSegment ?? '')}, ${String(speakerDetails?.data?.first_name ?? '')} ${String(speakerDetails?.data?.last_name ?? '')}`}
        image={getImageSrc(speakerDetails?.data?.company?.logo)}
        url={window.location.href}
        twitterCardType="summary"
        type="product"
      />
      <HeroSection
        title={t('best-in-class-speakers-will-share-their-expertise')}
        description={t('experience-top-experts-text')}
        buttonText={t('apply-as-speaker')}
        buttonURL={''}
      />
      <AttendeeInfo speaker={speakerDetails?.data} />
      <Sessions sessions={speakerDetails?.data?.sessions} />
      {speakerDetails?.data?.company && (
        <CompanyInfo company={speakerDetails.data.company} />
      )}
    </>
  );
};

export default SpeakerPage;
